import request from '@/utils/request'

// 查询列表
export function apiScpScSafetyStockFactorList (data) {
  return request({
    url: '/scp/scpScSafetyStockFactor/list',
    method: 'post',
    data: data
  })
}

// 修改
export function apiScpScSafetyStockFactor (data) {
  return request({
    url: '/scp/scpScSafetyStockFactor',
    method: 'put',
    data: data
  })
}

// 删除
export function apiScpScSafetyStockFactorDel (id) {
  return request({
    url: `/scp/scpScSafetyStockFactor/${id}`,
    method: 'delete'
  })
}

// 删除所有
export function apiScpScSafetyStockFactorRemoveAll (query) {
  return request({
    url: `/scp/scpScSafetyStockFactor/removeAll`,
    method: 'delete',
    data: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpScSafetyStockFactorNewExport (data) {
  return request({
    url: '/scp/scpScSafetyStockFactor/v2/export',
    method: 'post',
    data: data
  })
}

// 重算安全库存系数
export function apiScpScSafetyStockFactorRecalculate (version) {
  return request({
    url: `/scp/scpScSafetyStockFactor/recalculate/${version}`,
    method: 'post'
  })
}
